import React, { useState, useEffect } from 'react';
import './CaptchaPanel.css';

const CaptchaPanel = ({ captchaData, onSolve, onCancel }) => {
  const [solution, setSolution] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (captchaData) {
      setIsVisible(true);
      setSolution('');
    } else {
      setIsVisible(false);
    }
  }, [captchaData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (solution.trim()) {
      onSolve(solution.trim());
      setSolution('');
    }
  };

  if (!isVisible) return null;

  return (
    <div className="captcha-overlay">
      <div className="captcha-panel">
        <div className="captcha-header">
          <h3>CAPTCHA je obvezna</h3>
          <p>Za nadaljevanje vnesite resitev CAPTCHA.</p>
        </div>

        <div className="captcha-image-container">
          <img
            src={captchaData}
            alt="CAPTCHA"
            className="captcha-image"
          />
        </div>

        <form onSubmit={handleSubmit} className="captcha-form">
          <input
            type="text"
            className="captcha-input"
            placeholder="Vnesite CAPTCHA resitev"
            value={solution}
            onChange={(e) => setSolution(e.target.value)}
            autoFocus
            autoComplete="off"
          />
          
          <div className="captcha-actions">
            <button
              type="submit"
              className="btn btn-success"
              disabled={!solution.trim()}
            >
              <span className="btn-icon">?</span>
              Potrdi
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
            >
              <span className="btn-icon">?</span>
              Preklici
            </button>
          </div>
        </form>

        <div className="captcha-hint">
          Namig: vnesite znake, ki jih vidite na sliki zgoraj.
        </div>
      </div>
    </div>
  );
};

export default CaptchaPanel;
